import React from "react";
import { Stack, Progress } from "@chakra-ui/react";

export default function FullPageLoader() {
  return (
    <div className="flex flex-col w-full justify-center h-[calc(100vh-3rem)] px-2">
      <Stack>
        <Progress size="xs" isIndeterminate />
      </Stack>
    </div>
  );
}
